@if (form()) {
  <div class="flex-column">
    <div class="flex-row align-center mat-h2 gap-sm">
      Sepa-Konfiguration für Lastschriftmandate
      @for (action of actions(); track action.controlAction) {
        <lib-dynamic-form-action
          [hideLabel]="true"
          [action]="action"
          (callActionFunction)="callActionFunction($event)"
        />
      }
      <lib-help-icon
        (click)="showHelpForSepa()"
        style="margin-left: auto"
      />
    </div>

    <mat-divider/>
    <div class="flex-row">
      <kpi4me-form-element
        [formControlElement]="form().controls[EFormKeys.depositor]"
        [formData]="formData.depositor()"
      />
      <kpi4me-form-element
        [formControlElement]="form().controls[EFormKeys.creditorId]"
        [formData]="formData.creditorId()"
      />
    </div>

    <br>

    <div class="flex-row">
      <kpi4me-form-element
        [formControlElement]="form().controls[EFormKeys.iban]"
        [formData]="formData.iban()"
      />
      <kpi4me-form-element
        [formControlElement]="form().controls[EFormKeys.bic]"
        [formData]="formData.bic()"
      />
    </div>

    <br>

    <kpi4me-form-element
      [formControlElement]="form().controls[EFormKeys.purpose]"
      [formData]="formData.purpose()"
    />
  </div>

} @else {
  <mat-progress-bar
    mode="indeterminate"
  ></mat-progress-bar>
}
